module.exports = "<nav class=\"ms-tabs\">\n  <ul>\n    <li ng-repeat=\"tab in tabs\">\n      <a ui-sref=\"{{tab.state}}\" ui-sref-active-eq=\"active\">\n        <i class=\"material-icons\">{{tab.icon}}</i>\n        <span>{{tab.title}}</span>\n      </a>\n    </li>\n  </ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/tabs/tabs.html
// module id = 459
// module chunks = 22